import { BankAccount } from '@src/types'
import { ApiRes, api } from './client'

export interface CreateBankAccountPayload {
    holder: string
    iban: string
    bic?: string | null
}

export interface UpdateBankAccountPayload {
    holder?: string
    iban?: string
    bic?: string | null
    is_primary?: boolean
    platform_name?: string
}

// These endpoints return the (created/updated) bank account resource directly,
// not wrapped in a `{ bank_account: ... }` envelope.
export const createBankAccountForNaturalProfile = (
    naturalProfileId: string,
    payload: CreateBankAccountPayload
): ApiRes<BankAccount> =>
    api.post(
        `manage/natural-profiles/${naturalProfileId}/bank-accounts`,
        payload
    )

export const createBankAccountForLegalProfile = (
    legalProfileId: string,
    payload: CreateBankAccountPayload
): ApiRes<BankAccount> =>
    api.post(`manage/legal-profiles/${legalProfileId}/bank-accounts`, payload)

export const updateBankAccount = (
    bankAccountId: string,
    payload: UpdateBankAccountPayload
): ApiRes<BankAccount> =>
    api.put(`manage/bank-accounts/${bankAccountId}`, payload)

export const deleteBankAccount = (bankAccountId: string): ApiRes<null> =>
    api.delete(`manage/bank-accounts/${bankAccountId}`)
